module.exports = __webpack_public_path__ + "static/media/27.109dc4dc.png";